// Mirrors the backend AnnouncementInviteViewStatusEnum (whether the jobseeker has seen the invitation).
export enum AnnouncementInviteViewStatusEnum {
    New = 1,
    Seen = 2
}
